import { Alert, Card, Col, Form, Modal, Row, Select } from "antd";
import styled from "styled-components";

export const FormItem = styled(Form.Item)`
  .ant-form-item-label {
    padding: 0 0 4px;
  }
`;

export const CustomSelectFormItem = styled(FormItem)`
  .ant-select-selector {
    ${({ $empty }) =>
      $empty !== true ? "background-color: #d1e9ff !important;" : ""}
  }

  .ant-form-item-required::before {
    content: none !important;
  }

  .ant-form-item-explain,
  .ant-form-item-explain-connected {
    display: none !important;
  }
`;

export const CustomFormAlert = styled(Alert)`
  margin-bottom: 12px;
`;

export const DynamicCard = styled(Card)`
  > .ant-card-head {
    background-color: ${({ $required }) => ($required ? "#db011c" : "#ffe0e4")};

    .ant-card-head-title {
      color: ${({ $required }) => ($required ? "#FFF" : "#000")};
    }
  }

  min-width: 350px;
  width: 100%;
  height: 100%;

  .ant-form-item-control {
    max-width: 100%;
  }
`;

export const DynamicSelect = styled(Select)`
  width: ${({ $width }) => $width || "80%"} !important;
`;

export const DynamicCardWrapper = styled(Col)`
  padding: 8px;
`;

export const DynamicRow = styled(Row)`
  padding: 12px 24px 12px;
`;

export const CategoryTypeHeaderItem = styled.h1`
  padding: 12px 8px 4px;
  font-size: 24px;
  display: block;
  width: 100%;
  margin: 4px;
`;

export const SwitchText = styled.span`
  padding-right: 5px;
  vertical-align: middle;
`;

export const SwitchPanel = styled.div`
  margin-bottom: 24px;
  display: block;
  width: 100%;
`;

export const FullscreenModal = styled(Modal)`
  .ant-modal,
  .ant-modal-content {
    height: 100vh;
    width: 95vw;
    margin: 0;
    top: 0;
    left: -130%;
  }
  .ant-modal-body {
    height: calc(100vh - 110px);
  }
`;
